import React from 'react';
import Image from 'next/image';
import Section from './Section';
import { PROJECT_EXPERIENCE_EN } from './index';
import AdviceAvatar from '@/assets/resume-advice/advice-avatar.png';

const ProjectAdvice = () => {
  const [selectedTitle, setSelectedTitle] = React.useState('');

  return (
    <ul className="m-0 list-none">
      <Section
        title="写项目经历和写工作经历有什么区别？"
        adviceIndex={1}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-project-experience-2/"
        sectionGroup={PROJECT_EXPERIENCE_EN}
        isRecommend={true}
        defaultChecked={true}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            <strong>工作经历</strong>：展示“你做了什么”；
            <strong>项目经历</strong>：展示“你怎么做的”。
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>项目经历：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>作用：</strong>
                呈现你具体的工作方法和执行过程，展示你在某一项工作中的思考与细节，帮助强化你的专业能力和执行力。
              </li>
              <li>
                <strong>核心内容：</strong>
                深入描述你在项目中的思考、执行步骤以及项目的成果，特别是你如何克服挑战并推动项目成功。
              </li>
              <li>
                <strong>关注点：</strong>
                你是怎么做的，展示你对具体工作的深入理解，尤其是某一核心能力的运用及项目细节的把控。
              </li>
              <li>
                <strong>体现方式：</strong>
                详细描述项目背景、方法论、执行步骤及项目成果。项目经历侧重于具体方法、执行流程和深度思考，结果往往以项目结论或成果的形式呈现。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>工作经历：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>作用：</strong>
                明确展示你的岗位角色、核心能力和工作成果，帮助你建立清晰的职业形象和定位。
              </li>
              <li>
                <strong>核心内容：</strong>
                重点突出你在整个岗位上所承担的职责、如何管理团队或项目，以及你在这个职位上所取得的综合成果。
              </li>
              <li>
                <strong>关注点：</strong>
                你做了什么，特别是在你的岗位角色中，如何全面体现你所具备的核心能力。
              </li>
              <li>
                <strong>体现方式：</strong>
                概述工作职责和成就，围绕岗位角色进行全面的能力展示。工作成果可以简要提及，但需要和整体角色紧密结合，展示的是更高层次的职业成就。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>核心能力的体现：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>工作经历：</strong>
                需要涵盖你在整个职位上所需要的所有核心能力，确保用人单位可以全面了解你是否具备该岗位的完整能力组合。
              </li>
              <li>
                <strong>项目经历：</strong>
                重点体现一个核心能力的深度。对某个项目的执行思路、关键细节的把控和复盘更能展示你在特定领域的专长。
              </li>
            </ul>
          </li>
          <li>
            <strong>工作成果与项目成果：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>工作成果：</strong>
                可以是整体性的业绩提升或成果展示，避免具体数据，重点体现增长和管理贡献。
              </li>
              <li>
                <strong>项目成果：</strong>
                更注重项目目标的达成情况，通常要求具体描述项目的完成度、指标或其后续影响，能够更细致地反映你在项目上的实际贡献。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="一个完整的项目经历包含哪些内容？"
        adviceIndex={2}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-project-experience-1/"
        sectionGroup={PROJECT_EXPERIENCE_EN}
      >
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li>
            <strong>基础信息：</strong>项目名称、担任的角色、项目时间、规模等；
          </li>
          <li>
            <strong>整体概述：</strong>
            简单的对项目背景和过程、价值成果等进行总结，一般由一小段话组成；
          </li>
          <li>
            <strong>项目描述：</strong>具体地描述项目开展过程和方法论；
          </li>
          <li>
            <strong>项目成果：</strong>总结项目具体成果；
          </li>
          <li>
            <strong>项目回顾：</strong>对项目的总结和思考。
          </li>
        </ul>
      </Section>
      <Section
        title="项目经历模块一般需要呈现几个项目？应如何挑选项目？"
        adviceIndex={3}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-project-experience-3/"
        sectionGroup={PROJECT_EXPERIENCE_EN}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            项目经历应精炼、重点突出，最多不要超过3个。
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>不同职级对应的项目数量建议</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>高级管理者：</strong>
                1个项目，或者不需要此模块。高级管理者更多依赖于其战略性决策和领导能力，而非具体项目的执行，因此项目经历的数量可以精简甚至忽略。
              </li>
              <li>
                <strong>初级管理者：</strong>
                1-2个项目。作为管理者，既需要展现团队领导和项目管理能力，又需要显示出执行力，因此适合选择与此匹配的项目。
              </li>
              <li>
                <strong>执行岗：</strong>
                2个项目。这类岗位通常需要展示具体的执行能力，多个项目能够帮助用人单位全面了解其执行经验。
              </li>
              <li>
                <strong>没有正式工作经验：</strong>
                3个项目。没有正式经验的求职者可以从实习、校园项目等挑选经历，展现潜力和学习能力。
              </li>
            </ul>
          </li>
          <li>
            <strong>如何挑选项目：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>与职业定位和核心能力相匹配的项目：</strong>
                <ul className="!ml-5 list-disc">
                  <li>
                    <strong>匹配求职者的职级变化：</strong>
                    例如，从执行者晋升为初级管理者时，选取一个项目来展示你作为项目负责人的思考与决策能力，另一个项目展示你作为执行者的执行细节和对项目的贡献。
                  </li>
                  <li>
                    <strong>匹配职业发展方向：</strong>
                    选择能体现你希望在未来职业发展中的核心能力的项目。例如，若目标职位需要领导力，则应选择能展示项目管理或团队协作的项目。
                  </li>
                </ul>
              </li>
              <li>
                <strong>优先选取最新项目：</strong>
                <ul className="!ml-5 list-disc">
                  <li>
                    最新的项目最能展示你当前的工作水平和能力，避免使用时间久远且与当前职级不匹配的项目。
                  </li>
                  <li>
                    如果经历较长，早期项目通常与当前职业定位不符，容易造成混乱，应删除。
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="写项目经历常犯的五个错误"
        adviceIndex={4}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-project-experience-4/"
        sectionGroup={PROJECT_EXPERIENCE_EN}
      >
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>错误一：以写工作经历的方式来写项目经历</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>问题：</strong>
                工作经历主要描述你在某个岗位上承担的职责和取得的成果，而项目经历应重点展示你如何执行具体项目。很多求职者不加区分，将项目经历简单当作工作职责的延伸，缺乏对项目执行过程的深入描述。
              </li>
              <li>
                <strong>避免方法：</strong>
                项目经历应该按照项目的基础信息、项目背景、工作思路、执行过程、成果和回顾来详细展开，展示的是你在项目中的思考和方法论。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>错误二：缺少项目背景的介绍</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>问题：</strong>
                没有为读者提供项目背景，导致用人单位无法理解项目的实际意义。项目背景能够帮助用人单位快速了解该项目的重要性、难度和价值。如果背景不清晰，可能会让重要的项目看起来平淡无奇。
              </li>
              <li>
                <strong>避免方法：</strong>
                用简洁的语言清晰描述项目的背景，解释为什么要开展这个项目，以及你在其中的角色和贡献。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>错误三：不展示工作思路和执行方法</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>问题：</strong>
                仅仅列出“做了什么”，而没有说明“怎么做的”，让项目经历变成简单的任务清单，无法体现你的实际能力和思维过程。
              </li>
              <li>
                <strong>避免方法：</strong>
                要重点描述你在项目中的思路、面对的难点和挑战、以及你采取的具体策略，体现你在项目执行过程中所应用的技能和方法论。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>错误四：缺少总结和回顾</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>问题：</strong>
                没有对项目进行复盘和反思，失去了展示个人思考深度和提升空间的机会。回顾是对自己项目执行过程的反思，能够展示你对工作的理解和改进的思考。
              </li>
              <li>
                <strong>避免方法：</strong>
                在项目结束后进行回顾，指出项目中的得失，总结成功的经验或发现的问题，以及如果再做一次会有哪些改进。这部分能为简历增添思考力和职业态度。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>错误五：项目选择不当，数量过多或同质化</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>问题：</strong>
                选择项目时不加筛选，展示了过多同质化的项目，导致简历缺乏重点，反而弱化了你的能力展示。同时，挑选的项目如果时间久远或者与当前职业定位不符，也会显得不合适。
              </li>
              <li>
                <strong>避免方法：</strong>
                挑选最近的、与当前职位定位相匹配的项目，并通过不同的项目展示不同的核心能力。项目数量不宜超过3个，内容上避免重复或同质化的项目经历。
              </li>
            </ul>
          </li>
          <li>
            <strong>最后，可以参考下面的方式来思考要怎么讲好一个项目：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>【项目背景】</strong>
                这个事情的背景是什么，包括为什么会有这件事、做好了有什么意义；
              </li>
              <li>
                <strong>【项目思考】</strong>
                这个事我是怎么思考的，包括难点和挑战在哪里，主要的解决策略是什么；
              </li>
              <li>
                <strong>【项目执行】</strong>
                这个事情我是怎么做的，包括具体执行过程中的细节，涉及的知识和核心技能有哪些；
              </li>
              <li>
                <strong>【项目成果】</strong>
                这个事情最后做得怎样，包括有没有达成目标，收获了怎样的认可；
              </li>
              <li>
                <strong>【项目回顾】</strong>
                这个事情做完以后我是怎么想的，包括再做的话会怎样提升。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="没有实习和工作经历，如何完整展现你的能力？"
        adviceIndex={5}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-project-experience-5/"
        sectionGroup={PROJECT_EXPERIENCE_EN}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-2">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            极力推荐以<strong>项目</strong>
            的方式来展示自己在校内的工作和实践经历，将<strong>目标岗位</strong>
            的需求应该融入到校园经历中，
            <strong>确保所展示的能力与未来职业方向相关</strong>。
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="mb-8 leading-6.5 text-green-900/70">
          对于缺乏实习或正式工作经验的职场新人，校园经历是展示能力的重要机会。当你有明确的求职目标时，可以在校园经历中融入目标岗位的能力要求。
        </p>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>校园经历的可选范围：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                社团、学生会、校园竞赛、论文、课堂作业、志愿者活动等，选择的经历应与目标岗位密切相关。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>校园经历的描述技巧：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                描述校园经历时，不应仅仅提及做了什么，还需要
                <strong>深入展开细节</strong>，展示出执行过程中的
                <strong>思考和能力</strong>
                。这不仅展示了你完成了某项工作，更重要的是如何完成的。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>校园经历的描述结构：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>项目总述：</strong>简洁描述项目背景及你的核心职责。
              </li>
              <li>
                <strong>项目过程：</strong>
                详细阐述项目的执行过程，分项展开，注意：
                <ul className="!ml-5 list-disc">
                  <li>
                    将活动组织拆分成步骤，为其中的核心步骤进行描述并提供细节；
                  </li>
                  <li>
                    建议核心步骤不超过7项，最好能总结为3-5项，合并次要步骤。
                  </li>
                </ul>
              </li>
              <li>
                <strong>项目成果：</strong>
                描述项目最终的成果，注意区分项目整体成果与个人贡献。
              </li>
              <li>
                <strong>项目回顾：</strong>总结从中学到的内容。重点叙述：
                <ul className="!ml-5 list-disc">
                  <li>经历中的挑战；</li>
                  <li>对其关键点的思考；</li>
                  <li>引发和用人单位的讨论。</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        <p className="mb-3">示例：</p>
        <div className="border border-[#219653] border-dashed p-4 rounded-lg mb-4 text-black/85">
          <ul className="ml-6 leading-6.5">
            <li className="mb-3">
              <strong>校园经历：</strong>大学新年音乐会组织策划。
            </li>
            <li className="mb-3">
              <strong>项目总述：</strong>
              做为大学艺管委的演出部的核心成员，我参与组织策划了在中山公园音乐堂举办的2020
              年大学新年音乐会。
            </li>
            <li className="mb-3">
              <strong>项目过程：</strong>在此期间我的主要工作内容包括：
              <ul className="!ml-5 list-disc">
                <li>
                  与演出部共同确定音乐会的准备工作开展方法，包括整体组织计划和关键时间点；
                </li>
                <li>
                  作为主要的组织者与多个学生社团和部门交流，确认各个社团的节目，并从整体节目编排上提供反馈意见；
                </li>
                <li>
                  与多个演出场地进行协商并最终确认以中山公园做为演出地点；参与场地使用的细节沟通和注意事项并同步给其他部门，负责场地座位的具体编排；
                </li>
                <li>
                  参与新年音乐会的宣传工作，包括海报制作、校园广播和公众号活动文章编辑；
                </li>
                <li>
                  负责音乐会期间的摄影摄像，包括15个点位的协调，以及幕后场务；参与后期的摄影剪辑，以及呈现最终完整版音乐会现场记录视频。
                </li>
              </ul>
            </li>
            <li className="mb-3">
              <strong>项目成果：</strong>
              音乐会总参与人数超过千人，获得年度演出荣誉。
            </li>
            <li>
              <strong>项目回顾：</strong>
              我在这个校园经历中学习到了大型活动是如何组织开展的。此次新年音乐会的准备工作超过2个半月，在此期间有大量的细节需要思考、规划和沟通，同时要兼顾学业，期间的确有很多挑战，但最终取得了不错的成果。这类的活动也让我有机会对活动现场如何达到更好的效果、活动的宣传和后期剪辑上等话题产生了更多思考。期待和用人单位进行跟多的探讨。
            </li>
          </ul>
        </div>
        <p className="leading-6.5">以上的示例</p>
        <ul className="!ml-6 list-disc leading-6.5 text-black/85">
          <li>
            通过新年音乐会组织的细节工作步骤中体现出对如何
            <strong>执行的思考、以及呈现出执行能力</strong>；
          </li>
          <li>
            通过对音乐会的准备和策划过程，呈现出
            <strong>组织策划和协调能力</strong>；
          </li>
          <li>
            在项目回顾部分，呈现出营销岗位所需要的
            <strong>活动组织、创意、宣传和营销素材处理能力</strong>
            ，并引发和用人单位在这些话题上的探讨。
          </li>
        </ul>
      </Section>
    </ul>
  );
};

export default ProjectAdvice;
